import { Card, Flex, Table, Typography } from "antd";
import type { ColumnType } from "antd/lib/table";
import { ImpressaoContainer, ImpressaoHeader } from "components/Impressao";
import type { ApiCalculo } from "pages/calculo/types/ApiCalculo";
import { numberToCurrency } from "std/format";
import { roundAbnt } from "std/math";

const { Title } = Typography;

export const columns: ColumnType<ApiCalculo>[] = [
	{
		dataIndex: "calc_mes",
		key: "calc_mes",
		title: "Mês Ref",
	},
	{
		dataIndex: ["produtor", "for_codigoindividual"],
		key: "for_codigoindividual",
		title: "Produtor",
		render: (for_codigoindividual, record) => (
			<>
				{for_codigoindividual || ""} - {record?.produtor?.pessoa?.pes_nome_razaosocial || ""}
			</>
		),
	},
	{
		dataIndex: ["produtor", "rota", "transportador", "tra_codigoindividual"],
		key: "transportador",
		title: "Transportador",
		render: (tra_codigoindividual, record) => (
			<>
				{tra_codigoindividual || ""} - {record?.produtor?.rota?.transportador?.pessoa?.pes_nome_razaosocial || ""}
			</>
		),
	},
	{
		dataIndex: ["produtor", "for_banco"],
		key: "for_banco",
		title: "Banco",
	},
	{
		dataIndex: "calc_nfe_numero_doc",
		key: "calc_nfe_numero_doc",
		title: "NFE",
		align: "center",
		render: (calc_nfe_numero_doc, record) => (
			<>
				{calc_nfe_numero_doc
					? `${calc_nfe_numero_doc}/${record?.calc_nfe_serie_doc}`
					: record?.calc_nfe_chave
						? ` Chave Fiscal: ${record?.calc_nfe_chave}`
						: ""}
			</>
		),
	},
	{
		dataIndex: "calc_valor_unit",
		key: "calc_valor_unit",
		title: "Valor Leite",
		align: "right",
		render: (value, record) => (
			<span
				style={{
					color: !!record?.precoReferencia?.pr_valor && record?.precoReferencia?.pr_valor > value ? "#ff4d4f" : "",
				}}
			>
				{numberToCurrency(value)}
			</span>
		),
	},
	{
		dataIndex: "calc_valor",
		key: "calc_valor",
		title: "Créditos",
		align: "right",
		render: (value) => numberToCurrency(value || 0),
	},
	{
		dataIndex: "calc_desconto_geral",
		key: "calc_desconto_geral",
		title: "Descontos",
		align: "right",
		render: (value) => numberToCurrency(value || 0),
	},
	{
		dataIndex: "calc_valor_total",
		key: "calc_valor_total",
		title: "Total",
		align: "right",
		render: (value) => numberToCurrency(value || 0),
	},
];

export function TableRelFinanceiroProdutor({ data, title }: { data: ApiCalculo[] | undefined; title: string }) {
	const totalCreditos = roundAbnt((data || []).reduce((acc, cur) => acc + cur.calc_valor, 0));

	const totalDescontos = roundAbnt((data || []).reduce((acc, cur) => acc + cur.calc_desconto_geral, 0));
	const totalValor = roundAbnt((data || []).reduce((acc, cur) => acc + cur.calc_valor_total, 0));

	return (
		<ImpressaoContainer className="w-full mt-3" title={title}>
			<ImpressaoHeader title={title} />

			<Table
				rowKey="calc_idpk"
				columns={columns}
				dataSource={data}
				pagination={false}
				size="small"
				rowClassName="zebra"
				summary={(rows) => (
					<Table.Summary.Row>
						<Table.Summary.Cell index={0} align="left" className={"antd-table-td-top"}>
							<div style={{ display: "flex", marginTop: "8px" }}>
								<Flex vertical={true}>
									<Title level={5}>Registros:</Title>
									<Title level={5} style={{ margin: "0px", textAlign: "right" }}>
										{rows?.length || 0}
									</Title>
								</Flex>
							</div>
						</Table.Summary.Cell>

						<Table.Summary.Cell index={1} colSpan={7} align="right">
							<Flex className="w-full mt-3" justify={"end"}>
								<Card
									title={
										<Flex className="w-full" align="center" justify="center">
											Totais
										</Flex>
									}
									bordered={false}
									size={"small"}
									style={{ width: 300 }}
								>
									<Flex
										className="w-full"
										justify={"space-between"}
										style={{
											fontWeight: "bold",
											fontFamily: "Mukta",
										}}
									>
										Créditos: <b>{numberToCurrency(totalCreditos || 0)}</b>
									</Flex>
									<Flex
										className="w-full"
										justify={"space-between"}
										style={{
											fontWeight: "bold",
											fontFamily: "Mukta",
										}}
									>
										Descontos: <b>{numberToCurrency(totalDescontos || 0)}</b>
									</Flex>
									<Flex
										className="w-full"
										justify={"space-between"}
										style={{
											fontWeight: "bold",
											fontFamily: "Mukta",
										}}
									>
										Total: <b>{numberToCurrency(totalValor || 0)}</b>
									</Flex>
								</Card>
							</Flex>
						</Table.Summary.Cell>
					</Table.Summary.Row>
				)}
			/>
		</ImpressaoContainer>
	);
}
